import { pow } from "mathjs";
import React, { FC, useMemo } from "react";
import { localeStringOptions } from "../../../../../../common/constants/common.constants";
import { ISellPermissionConfig } from "../../../../../../common/interfaces/clubs.interface";
import "./SellPermissionItem.scss";

const SellPermissionItem: FC<{
  sellPermission: ISellPermissionConfig;
  permissionIndex: number;
  mintSymbol: string;
  mintDecimals: number;
  divideByLamports?: boolean;
  isItemBlur?: boolean;
  isItemLast?: boolean;
}> = ({
  sellPermission,
  permissionIndex,
  isItemBlur,
  isItemLast,
  divideByLamports,
  mintSymbol,
  mintDecimals,
}) => {
  const permissionItemClassName = useMemo(() => {
    return permissionIndex === 0 && isItemLast
      ? "sell-permission-item sell-permission-item--single"
      : permissionIndex === 0
      ? "sell-permission-item sell-permission-item--round"
      : isItemBlur
      ? "sell-permission-item sell-permission-item--blur"
      : isItemLast
      ? "sell-permission-item sell-permission-item--last"
      : "sell-permission-item";
  }, [isItemLast, permissionIndex, isItemBlur]);

  const getSellPermissionAmount = useMemo(() => {
    return (permissionAmount: number) => {
      return divideByLamports
        ? permissionAmount / Number(pow(10, mintDecimals))
        : permissionAmount;
    };
  }, [divideByLamports]);

  return (
    <div className={permissionItemClassName}>
      <p className="sell-permission-item__index">{permissionIndex + 1}.</p>
      <p className="sell-permission-item__from">
        From{" "}
        <span>
          {getSellPermissionAmount(sellPermission.from).toLocaleString(
            undefined,
            localeStringOptions
          )}{" "}
          {mintSymbol}
        </span>
      </p>
      <p className="sell-permission-item__to">
        To{" "}
        <span>
          {getSellPermissionAmount(sellPermission.to).toLocaleString(
            undefined,
            localeStringOptions
          )}{" "}
          {mintSymbol}
        </span>
      </p>
      <p className="sell-permission-item__quorum">
        At least <span>{sellPermission.votingQuorum} % votes</span>
      </p>
    </div>
  );
};

export default SellPermissionItem;
